import PropTypes from 'prop-types';

const intlPropTypes = PropTypes.shape({
  T: PropTypes.func.isRequired,
  urlResolver: PropTypes.shape({
    absolutizePath: PropTypes.func.isRequired,
    formatHrefURL: PropTypes.func.isRequired,
    getAnswersUrl: PropTypes.func.isRequired,
    getBaseUrl: PropTypes.func.isRequired,
    getBlogUrl: PropTypes.func.isRequired,
    getContactUrl: PropTypes.func.isRequired,
    getFbAuthUrl: PropTypes.func.isRequired,
    getGoogleAuthUrl: PropTypes.func.isRequired,
    getLoginUrl: PropTypes.func.isRequired,
    getRecoverAccountUrl: PropTypes.func.isRequired,
    getRegisterUrl: PropTypes.func.isRequired,
    getSearchUrl: PropTypes.func.isRequired,
    getConversationUrl: PropTypes.func.isRequired,
    getConversationBookingUrl: PropTypes.func.isRequired,
    getPaymentUrl: PropTypes.func.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  formatDate: PropTypes.func.isRequired,
  toLocalizedString: PropTypes.func.isRequired,
});

export default intlPropTypes;
